<template>

  <div style="width:100%;">
    <el-container style="padding: 0% 20% 0% 20%;">
      <el-header height>
        <el-row>
          <div class="top-left">
            <h2>{{data.title}}</h2>
          </div>
        </el-row>
        <el-row style="margin-bottom:20px;">
          <div  style="text-align: center">
            <span>
              <label>发稿人:</label>&nbsp;
              <label>{{data.drafter}}</label>&nbsp;
              <label>发稿时间：</label>
              <label>{{data.createTime | dateformat('yyyy-MM-dd HH:mm:ss')}}</label>
            </span>
          </div>
        </el-row>
      </el-header>
      <el-main >
        <el-row v-if="data.isUrl=='false'" v-html="data.content" class="content"></el-row>
        <div v-if="data.isUrl=='true'">
          <iframe
            ref="iframe"
            :src="data.url"
            style="width:100%;"
            :height="data.pageHeight+'px'"
            frameborder="0"
          ></iframe>
        </div>
        <el-row v-if="data.file">
          <span style="font-size: 15px;font-weight: bold;">附件:</span>
          <div v-for="(item,i) in JSON.parse(data.file)" :key="i">
            <div>
              <el-tag  @click="preview(item)">{{item.name}}</el-tag>
              <el-button icon="el-icon-download" @click="download(item)" style="download" type="primary" size="mini">下载</el-button>
            </div>
          </div>
          <IframeSrc ref="iframeSrcSearch" :iframeSrc="iframeSrc" :fileRow="fileRow"/>
        </el-row>
      </el-main>

    </el-container>
  </div>
</template>
<script>
import EipAttachment from "@/components/eipControl/EipAttachment.vue";
import req from "@/request.js";
import IframeSrc from "@/components/common/iframeSrc.vue";
import { mapState } from "vuex";
export default {
  name: "haiyaMails",
  components: { EipAttachment,IframeSrc },
  data() {
    return {
      dialogVisible: false,
      data: {
      },
      iframeSrc:"",
      fileRow:null,
    };
  },
  created() {
    
  },
  mounted(){
    req.post(window.context.portal +"/bpm/haiyaapi/getMailsNewsId").then((response) => {
      this.init(response.data.newid);
      let param = {
        xm:'/',
        gh:'/',
        ggbt:"",
        ggbm:response.data.newid,
      };
      req.post(window.context.bpmRunTime + "/message/SaveNewsItem", param).then(resp => {//插入查阅记录表
      });
    });
  },
  methods: {
      preview(item) {//附件预览
      let row = item;
      let fileid = row.id;
      let idocType = ["doc","docx","xls","xlsx","ppt","pptx","pdf","txt","jpg","jpeg","gif","png","bmp","tif","mp3","m4a","mid","wma","mp4","zip","rar","tar","7z"];      
      let type;// = row.name.substr(row.name.lastIndexOf(".") + 1);
      this.$http.post(`${window.context.portal}/bpm/aliasScript/v1/execute/FileType?id=${fileid}`).then((resp) => {
         type = resp.data.value[0].FILETYPE;
         setTimeout(() => {
          if (idocType.includes(type)) {
            let token = "testtoken";
            let url = encodeURIComponent(window.context.portal+"/system/file/v1/downloadFile?fileId=" +row.id);
            let idocvUrl = "http://10.10.10.74:8168";
            //***** 外网 *****/
            if(window.location.origin.indexOf("http://61.144.170.91")>-1){//副线环境
              idocvUrl = "http://61.144.170.91:8168";
            }

            if(window.location.origin.indexOf("http://zs.haiya.com.cn")>-1){//副线环境
              idocvUrl = "http://61.144.170.91:8168";
            }


            this.$http.get(`${idocvUrl}/doc/upload?token=${token}&url=${url}`).then((resp) => {
              console.log("预览");
                this.fileRow = row;
                this.iframeSrc = idocvUrl+"/view/" + resp.data.uuid;
                this.$refs.iframeSrcSearch.handleOpen();
              });
          }else{
              this.$http.get(`${window.context.portal}/system/file/v1/downloadFile?fileId=${fileid}`).then((resp) => {
                this.$message({
                message: '此附件类型暂不支持在线查看，开始为您下载到本地中查看！',
                type: 'success'
            })
              });
          }
        }, 500);
      });
    },
    downloadFile(item) {//附件下载
      req.download("${portal}/system/file/v1/downloadFile?fileId=" + item.id);
    },
    openDialog() {
      this.dialogVisible = true;
    },
    init(id) {
      req.get(window.context.portal + "/portalNewsNotice/v1/getNewsById?id=" + id)
        .then(response => {
          if (
            response.data.rotatingDisplayPictures &&
            response.data.type == 1
          ) {
            response.data.imgUrl = window.context.portal + "/system/file/v1/downloadFile?fileId=" + response.data.rotatingDisplayPictures;
          }
          this.data = response.data;
          $(".el-aside").hide();
        });
    },
    //附件下载
      download(item) {
      if (!item.response){
        req.download("${portal}/system/file/v1/downloadFile?fileId=" +  item.id);
      }else{
        req.download("${portal}/system/file/v1/downloadFile?fileId=" +  item.response.fileId);
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.el-container {
  background-color: #fff;
}

.el-header {
  padding-top: 10px;
  // border: 1px solid #e7eaec;
}

.el-row {
  margin-top: 10px;
}

.el-main {
  border-bottom: 1px solid #e7eaec;
}

.content {
  margin-bottom: 30px;
}

.folder {
  border-top: 1px solid #e7eaec;
}

.foots {
  line-height: 40px;
}

.el-card {
  width: 300px;
  margin-top: 20px;
}

.fonts {
  color: #4ec1c3;
  margin-left: 10px;
}

.footed {
  float: right;
  margin-top: 10px;
}

.top-left {
  text-align: center;
}

.top-right {
  float: right;
  display: inline-block;
}

.files {
  cursor: pointer;
  font-size: 12px;
  color: #5eade6;
}

.files:hover {
  color: $--theme-color;
}

.fj_left {
  padding: 0 15px;
  border-left: 1px solid #d8d8d8;
}

.fj_right {
  padding: 0 15px 0 0;
}

.done-subject {
  cursor: pointer;
}

.done-subject {
  color: $--theme-color;
}
/deep/.el-dialog__wrapper{
    overflow: unset !important;
  }
/deep/.el-dialog__body {
  height: calc(100% - 124px);
  overflow-y: auto;
}
/deep/.el-dialog{
  height: 90% ;
}
@media (max-height: 960px) {
  /deep/ .el-dialog__body{
    .el-container{
      height: 100%;
    }
  }
}

/deep/ label{
  font-size: 16px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 400;
  color: #292B44;
}

/deep/ h2{
  font-size: 24px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #292B44;
}

/deep/ strong{
  font-size: 16px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 400;
  color: #292B44;
}
</style>
